export default __webpack_public_path__ + "static/media/ungaLogo.d446875a.png";